'use client';
import type { CSSProperties, ReactElement } from 'react';
import { FontWeight } from '@/theme/typography';
import { CmarkdownLabelText } from '../Cmarkdowntext/CmarkdownLabelText';
import { FlowchartLabelOrigin } from './parse-mermaid-flowchart';
const FLOWCHART_LABEL_TEXT_ALIGN_CENTER = 'center';
const UNRESOLVED_LABEL_STYLE: CSSProperties = {
    fontSize: 12,
    fontWeight: 500,
    lineHeight: '17px',
    textAlign: 'center',
    letterSpacing: 0.4,
    fontStyle: 'italic',
};
export interface FlowchartNodeLabelProps {
    label: string;
    labelOrigin: FlowchartLabelOrigin;
    textColor: string;
}
export function FlowchartNodeLabel({ label, labelOrigin, textColor, }: FlowchartNodeLabelProps): ReactElement {
    if (labelOrigin === FlowchartLabelOrigin.Unresolved) {
        return (
      <span style={{
                ...UNRESOLVED_LABEL_STYLE,
                color: textColor,
            }}>
        {label}
      </span>
      );
    }
    return (
    <CmarkdownLabelText dataElScope="Cmarkdownflowchart/FlowchartNodeLabel" content={label} size={13} weight={FontWeight.Medium} textAlign={FLOWCHART_LABEL_TEXT_ALIGN_CENTER} style={{ width: '100%' }} paragraphStyle={{ marginBottom: 0, justifyContent: 'center', width: '100%' }} textStyle={{ color: textColor, lineHeight: '18px' }}/>
    );
}
